module.exports = __webpack_public_path__ + "img/signal.dc6033a2.jpg";